<template>
  <div class="dashboard-container">
    <div class="app-container">标签管理</div>
  </div>
</template>

<script>
export default {
  name: 'TagsList',
  data() {
    return {}
  }
}
</script>

<style scoped>
</style>
